import Seo from "./Seo";
import home2svg from "../assets/home2.svg";
import one from "../assets/one.png";
import two from "../assets/two.png";
import three from "../assets/three.png";
import four from "../assets/four.png";
import SSL from "../assets/SSL-Certification.png";
import ISO from "../assets/ISO-Certification.png";
import SASE from "../assets/SASE-Certification.png";
import GDR from "../assets/GDR-Certification.png";
import CIS from "../assets/CIS-Certification.png";
// import aiOCR from "../assets/AI-OCR.gif";
import aiOCR2 from "../assets/AI-OCR2.mp4";
import azure from "../assets/azure-logo.png";
import aws from "../assets/aws-logo.png";
import google from "../assets/google-cloud-logo.png";
import whatsapp from "../assets/whatsapp.png";
import gmail from "../assets/gmail.png";
import messages from "../assets/messages.png";
import booking from "../assets/booking.gif";
import secure from "../assets/secure.mp4";
import allinone from "../assets/all-in-one.mp4";
import acc_1 from "../assets/Signature.svg";
import acc_2 from "../assets/Postcard.svg";
import acc_3 from "../assets/accordian.png";
import sec6 from "../assets/home-section-6.gif";
import { useEffect, useState, lazy, Suspense } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { validateEmail } from "../utils/validation";
import BookDemo from "./pages/products/BookDemo";
import { FaStar, FaPlay } from "react-icons/fa";
import CounterOnView from "./ui/CounterOnView";
import { Accordion } from "react-bootstrap";
import { MdTrackChanges, MdDescription, MdVerifiedUser } from "react-icons/md";
import useIsMobile from "../hooks/useIsMobile";
import vergadoVoice from "../assets/audio/vergado_male_voice.mp3"; // adjust path
import WithoutVergado from "../assets/WithoutVergado.gif";
import WithVergado from "../assets/WithVergado.gif";
import LazyVideo from "./ui/LazyVideo";
import VideoModal from "./ui/VideoModal";

const VERGADO_OVERVIEW_VIDEO_ID = "rD4p8s2GPJA";

// Both pull in a heavy library (wavesurfer.js / three.js) that isn't needed
// for first paint — split into their own chunks so they load in parallel
// instead of being parsed as part of the main bundle. Same lazy() pattern
// App.js already uses for every route.
const AudioWavePlayer = lazy(() => import("./AudioWavePlayer"));
const ParticleBackground = lazy(() => import("./ui/ParticleBackground"));

const Home = () => {
  const [activeTab, setActiveTab] = useState("without-vergado");
  const [email, setEmail] = useState("");
  const [isValidate, setIsValidate] = useState("");
  useEffect(() => {
    console.log("isValidate", isValidate);
  }, [isValidate]);
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const [showVideo, setShowVideo] = useState(false);

  const handleChange = (value) => {
    setEmail(value);
  };

  const handleBookDemo = () => {
    const Validate = validateEmail(email);
    if (!Validate) {
      setIsValidate("Please enter your work Email");
      return;
    }
    handleShow();
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = useIsMobile();
  const homeSeoLongDescription =
    "Indian HR and finance teams usually manage payroll across multiple spreadsheets, attendance exports, tax calculators, and bank files. That setup slows every month-end close and creates compliance risk when one value is missed. Vergado replaces this fragmented workflow with a single automated HRMS built for India. From attendance capture to salary disbursal, every step runs in sequence with approval trails, role-based controls, and real-time visibility. Teams no longer chase documents, copy values between tools, or manually prepare challans and returns at midnight before statutory deadlines. On the payroll side, Vergado calculates CTC structures, prorations, overtime, arrears, bonuses, and contractor payouts with configurable rules for different workforce types. The platform then handles TDS computation under salary provisions, EPF and ESI contributions, and state-wise Professional Tax obligations automatically. For people teams, onboarding workflows collect KYC and employment documents, trigger background verification, and push clean employee masters straight into payroll. For finance teams, expense claims with OCR bill capture, policy checks, and approval routing flow into reimbursement and accounting exports without re-keying data. Vergado also improves take-home experience for employees. Benefits wallets for meal, fuel, telecom, and other eligible components help structure compensation more efficiently while staying aligned to Indian tax rules. Field-heavy organizations can digitize petty cash through prepaid cards, and businesses that want retention support can offer earned wage access without putting employer working capital at risk. Integrations with attendance systems, accounting software, and enterprise identity tools reduce adoption friction. Security is handled through enterprise cloud infrastructure, encryption practices, and auditable logs that support internal governance and external reviews. The result is a faster payroll cycle, fewer compliance escalations, cleaner data between HR and finance, and a better employee experience from joining to payout. Whether you are a startup scaling beyond your first HR hire or a multi-location company managing thousands of employees, Vergado gives you one operating layer for payroll, compliance, benefits, expenses, onboarding, and cash operations. If your team wants to move from manual coordination to predictable automation, a live demo can show the exact workflow for your org structure and policies.";

  return (
    <>
      {/* <!-- ======= Hero Section ======= --> */}
      <Seo
        title="Vergado | HRMS India & Automated Payroll Software | TDS EPF ESI PT Automation"
        description="Vergado is an HRMS India platform and automated payroll software for TDS, EPF, ESI and PT automation, statutory compliance, and multi-tenant HR operations."
        path="/"
        keywords="HRMS software India, automated payroll software India, payroll compliance automation, TDS filing automation, EPF ESI PT filing software, employee benefits platform India, expense management software India, onboarding software India, multi-tenant HRMS, enterprise HR automation"
        schema={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is Vergado?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Vergado is India's only fully automated HRMS. It runs payroll, statutory compliance (TDS, EPF, ESI and PT payments and filings), employee benefits, expense management and onboarding end-to-end on a single multi-tenant SaaS platform, so Indian businesses can operate HR with near-zero manual work.",
                },
              },
              {
                "@type": "Question",
                name: "Does Vergado handle TDS, EPF, ESI and PT automatically?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Yes. Vergado computes, pays and files TDS (Section 192 salary TDS), EPF (Employees' Provident Fund), ESI (Employees' State Insurance) and Professional Tax (PT) across Indian states automatically every pay cycle. Challans, returns and acknowledgements are generated and stored without any manual intervention.",
                },
              },
              {
                "@type": "Question",
                name:
                  "What makes Vergado different from other HRMS platforms in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Most HRMS products in India stop at calculations and leave you to pay and file statutory dues yourself. Vergado is the only HRMS in India that closes the loop — it calculates, pays and files TDS, EPF, ESI and PT for you, and also automates salary disbursal, benefits, expenses and onboarding end-to-end.",
                },
              },
              {
                "@type": "Question",
                name: "Which businesses is Vergado built for?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Vergado is built for Indian businesses of every size — startups, SMBs, and mid-market companies with white-collar, blue-collar, field and contract workforces. Its multi-tenant SaaS architecture scales from 10 employees to 10,000+ without changing systems.",
                },
              },
              {
                "@type": "Question",
                name: "Is Vergado secure and compliant?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Yes. Vergado is ISO 27001, SOC 2 and GDPR aligned, hosted on enterprise cloud infrastructure (AWS, Azure, Google Cloud) and built for Indian statutory compliance including EPFO, ESIC, Income Tax and state-wise Professional Tax requirements.",
                },
              },
              {
                "@type": "Question",
                name: "How do I get started with Vergado?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text:
                    "Book a free 30-minute demo from vergado.io or email sales@vergado.in. The team will walk you through payroll, compliance and benefits automation for your specific workforce before you switch.",
                },
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Vergado Home",
            url: "https://www.vergado.io/",
            description: homeSeoLongDescription,
            about: [
              { "@type": "Thing", name: "HRMS software India" },
              { "@type": "Thing", name: "Automated payroll software India" },
              {
                "@type": "Thing",
                name: "TDS EPF ESI PT compliance automation",
              },
              { "@type": "Thing", name: "Employee benefits and expenses" },
              { "@type": "Thing", name: "Onboarding and payroll integration" },
            ],
          },
        ]}
      />
      <section
        id="hero-main"
        className="d-flex"
        style={{ overflow: "hidden" }}
      >
        <Suspense fallback={null}>
          <ParticleBackground />
        </Suspense>

        <div
            className="container-fluid container-lg position-relative"
            style={{ zIndex: 2 }}
          >
            <div className="row align-items-center min-vh-100 py-5">
              <div
                className="col-12 col-md-6 mb-4 mb-lg-0"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="text-center text-lg-start">
                  <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center mb-3 gap-3 gap-lg-4">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-hand-thumbs-up-fill me-2 color-2"></i>
                      <span className="fw-semibold color-2">
                        Trusted by 35,000+ employees
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className="bi bi-star-fill me-1"
                          style={{ color: "#ffc107" }}
                        ></i>
                      ))}
                      <span className="fw-semibold ms-2 color-2">
                        1,000+ reviews
                      </span>
                    </div>
                  </div>
                  <h1>
                    <span style={{ display: "block" }}>Automating</span>
                    {windowWidth > 992 && windowWidth < 1400 ? (
                      <>
                        <span>Employee</span> <span>Journeys</span>
                      </>
                    ) : (
                      <span>Employee Journeys</span>
                    )}
                  </h1>
                  <p className="color-2">
                    India's only fully automated HRMS. Run payroll, benefits,
                    expenses and onboarding on autopilot — with automatic TDS,
                    EPF, ESI and PT payments and filings.
                  </p>
                  <Suspense fallback={<div style={{ height: "45px" }} />}>
                    <AudioWavePlayer audioFile={vergadoVoice} />
                  </Suspense>
                  <p className="color-2 mt-2">
                    Want to hear how I work? Hit play — I'll explain.
                  </p>
                  <div className="mt-3">
                    <button
                      className="cta-button"
                      onClick={() => {
                        handleShow();
                      }}
                    >
                      Book your 30-minute demo
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div
                  className="d-flex justify-content-center"
                  {...(!isMobile && {
                    "data-aos": "fade-left",
                    "data-aos-delay": "400",
                  })}
                >
                  <img
                    style={{ width: "86%" }}
                    src={home2svg}
                    alt="Payroll automation"
                    className="img-fluid"
                    width="1804"
                    height="1556"
                  />
                </div>
              </div>
            </div>
          </div>
      </section>
      <main id="main">
        {/* <!-- ======= Product Video Section ======= --> */}
        <section id="watch-video" className="py-5">
          <div className="container-fluid container-lg">
            <div className="row align-items-center">
              <div
                className="col-lg-6 mb-4 mb-lg-0 text-center text-lg-start"
                data-aos="fade-right"
              >
                <h2 className="color-3">
                  See Vergado run your{" "}
                  <span className="color-1">entire HR stack</span>
                </h2>
                <p className="color-2">
                  Payroll, statutory compliance, benefits, expenses and
                  onboarding — watch how it all runs on autopilot in one
                  platform.
                </p>
                <button
                  className="cta-button d-inline-flex align-items-center"
                  onClick={() => setShowVideo(true)}
                >
                  <FaPlay style={{ marginRight: 10, fontSize: "0.8rem" }} />
                  Watch the product tour
                </button>
              </div>
              <div className="col-lg-6" data-aos="fade-left">
                <div
                  className="video-thumb-wrapper shadow-lg"
                  onClick={() => setShowVideo(true)}
                  role="button"
                  tabIndex={0}
                  aria-label="Play Vergado product tour video"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      setShowVideo(true);
                    }
                  }}
                >
                  <img
                    src={`https://img.youtube.com/vi/${VERGADO_OVERVIEW_VIDEO_ID}/maxresdefault.jpg`}
                    alt="Vergado product tour video preview"
                    loading="lazy"
                  />
                  <span className="video-play-btn">
                    <FaPlay style={{ marginLeft: "3px" }} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- End Product Video Section --> */}

        <section id="banner" className="banner">
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div
              className="px-3 px-md-4 py-3 rounded-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 p-bg-color"
              style={{ minHeight: "150px" }}
            >
              <div className="d-flex align-items-start flex-grow-1">
                <div
                  className="d-flex align-items-center justify-content-center me-3 p-bg-color"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 6,
                    flexShrink: 0,
                  }}
                >
                  <FaStar color="white" />
                </div>
                <div
                  className="text-white fw-bold"
                  style={{ fontSize: "1rem", maxWidth: 400 }}
                >
                  Automating compliance and processes, sit back and let Vergado
                  handle the work!
                </div>
              </div>

              <div className="d-flex flex-column align-items-center justify-content-center text-white flex-grow-1 text-center w-100">
                <small className="mb-1" style={{ fontSize: "0.7rem" }}>
                  Want to see Vergado in action?
                </small>
                <button
                  className="btn btn-light btn-sm px-3 fw-semibold"
                  onClick={() => setShowVideo(true)}
                >
                  See how it works
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- End Banner Section --> */}

        {/* <!-- ======= Vergado Card Section ======= --> */}
        <section
          id="vergado-card"
          className="vergado-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="container">
            <div className="section-title text-center" data-aos="fade-up">
              <h2>
                The only platform that can support your <br />
                company at any scale
              </h2>
            </div>

            {/* First row */}
            <div className="row justify-content-center">
              <div className="col-md-7 mb-4">
                <Link
                  to="/products/payroll"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    className="p-4 rounded-4 d-flex flex-column justify-content-between card-lift"
                    style={{
                      backgroundColor: "#3D00F7",
                      color: "white",
                      minHeight: "500px",
                      position: "relative",
                      overflow: "hidden",
                      "--hover-bg-color": "rgba(49, 32, 126, 0.4)",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="w-80">
                        <h5 className="fw-bold">
                          From Salary Calculations to Tax Payments
                        </h5>
                        <h5 className="mb-3 fw-bold">We Handle It All</h5>
                        <small>
                          Automate payroll processing, ensure accurate salary
                          transfers, handle tax payments, and stay
                          compliant—without the manual effort.
                        </small>
                      </div>
                      <div
                        className="w-20 d-flex justify-content-end align-items-start"
                        style={{ position: "relative" }}
                      >
                        <span
                          className="card-link"
                          style={{
                            fontSize: "24px",
                            cursor: "pointer",
                            lineHeight: "1",
                          }}
                          aria-label="Arrow icon"
                        >
                          &#8599;
                        </span>
                      </div>
                    </div>

                    {/* Absolutely positioned image */}
                    <img
                      src={one}
                      alt="Salary Illustration"
                      className="img-fluid rounded"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        bottom: "0",
                        right: "0",
                        width: "auto",
                        height: "45%",
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </Link>
              </div>

              <div className="col-md-5 mb-4">
                <Link
                  to="/products/expense-management"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    className="p-4 rounded-4 d-flex flex-column justify-content-between card-lift"
                    style={{
                      backgroundColor: "#2E244A",
                      color: "white",
                      minHeight: "500px",
                      position: "relative",
                      overflow: "hidden",
                      "--hover-bg-color": "rgba(67, 60, 97, 0.4)",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="w-80">
                        <h5 className="mb-3 fw-bold">
                          Faster Expense Approvals & Seamless Reconciliation
                        </h5>
                        <small>
                          Automate expense submissions, speed up approvals, and
                          reconcile finances effortlessly—saving time and
                          reducing errors.
                        </small>
                      </div>
                      <div
                        className="w-20 d-flex justify-content-end align-items-start"
                        style={{ position: "relative" }}
                      >
                        <span
                          className="card-link"
                          style={{
                            fontSize: "24px",
                            cursor: "pointer",
                            lineHeight: "1",
                          }}
                          aria-label="Arrow icon"
                        >
                          &#8599;
                        </span>
                      </div>
                    </div>
                    <img
                      src={two}
                      alt="Salary Illustration"
                      className="img-fluid rounded"
                      loading="lazy"
                      style={{
                        position: "absolute",
                        bottom: "-17px",
                        right: "-2px",
                        width: "auto",
                        height: "45%",
                        margin: 0,
                        padding: 0,
                      }}
                    />
                  </div>
                </Link>
              </div>
            </div>

            <div className="row justify-content-center">
              {/* Second row */}
              <div className="col-md-5 mb-4">
                <Link
                  to="/products/cash"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div
                    className="p-4 rounded-4 d-flex card-lift"
                    style={{
                      backgroundColor: "#8A71FF",
                      color: "white",
                      minHeight: "500px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      <div className="w-80">
                        <h5 className="fw-bold">
                          Manage Petty Cash, Salary Advances
                        </h5>
                        <h5 className="mb-3 fw-bold">
                          & Tax-Saving Benefits with Ease
                        </h5>
                        <small>
                          Simplify petty cash tracking, provide salary advances,
                          and help employees save taxes with specially curated
                          benefits.
                        </small>
                      </div>
                      <div
                        className="w-20 d-flex justify-content-end align-items-start"
                        style={{ position: "relative" }}
                      >
                        <Link
                          className="card-link"
                          style={{
                            fontSize: "24px",
                            cursor: "pointer",
                            lineHeight: "1",
                          }}
                          aria-label="Arrow icon"
                          // to="/products/advances"
                        >
                          &#8599; {/* Unicode arrow pointing top right */}
                        </Link>
                      </div>
                    </div>

                    <div
                      className="w-100 d-flex justify-content-center"
                      style={{
                        position: "absolute",
                        bottom: "0",
                      }}
                    >
                      <img
                        src={three}
                        alt="Illustration"
                        className="img-fluid rounded"
                        loading="lazy"
                        style={{
                          height: "45%",
                          margin: 0,
                          padding: 0,
                        }}
                      />
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-md-7 mb-4">
                <div
                  className="p-4 rounded-4 d-flex card-lift"
                  style={{
                    backgroundColor: "#3D00F7",
                    color: "white",
                    minHeight: "500px",
                    position: "relative",
                    overflow: "hidden",
                    "--hover-bg-color": "rgba(49, 32, 126, 0.4)",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="w-80">
                      <h5 className="mb-3 fw-bold">
                        Keep Your Employees Safe & Informed
                      </h5>
                      <small>
                        Track employee travel, manage grievances, and send
                        instant updates with smart notifications.
                      </small>
                    </div>
                    <div
                      className="w-20 d-flex justify-content-end align-items-start"
                      style={{ position: "relative" }}
                    >
                      <Link
                        className="card-link"
                        style={{
                          fontSize: "24px",
                          cursor: "pointer",
                          lineHeight: "1",
                        }}
                        aria-label="Arrow icon"
                      >
                        &#8599; {/* Unicode arrow pointing top right */}
                      </Link>
                    </div>
                  </div>
                  <img
                    src={four}
                    alt="expese"
                    className="img-fluid rounded"
                    loading="lazy"
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      width: "auto",
                      height: "50%",
                      margin: 0,
                      padding: 0,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- End Vergado Card Section --> */}
        <section
          id="withorwithout"
          data-aos="fade-up"
          data-aos-delay="100"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div className="container">
            <div className="section-title text-center" data-aos="fade-up">
              <h2>
                Transition from chaos to
                <span className="d-inline d-md-block">
                  {" "}
                  organized efficiency
                </span>
              </h2>
            </div>

            <div className="text-center">
              <button
                className={`tab-btn ${
                  activeTab === "without-vergado" ? "active" : ""
                }`}
                style={{ width: "250px" }}
                onClick={() => setActiveTab("without-vergado")}
              >
                Without Vergado
              </button>
              <button
                className={`tab-btn ${activeTab === "vergado" ? "active" : ""}`}
                style={{ width: "250px" }}
                onClick={() => setActiveTab("vergado")}
              >
                Vergado
              </button>
            </div>

            <AnimatePresence mode="wait">
              {activeTab === "without-vergado" && (
                <motion.div
                  key="without-vergado"
                  className="text-center mt-5"
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -16 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <h3 className="color-2">
                    Decentralized chaos of docs and emails
                  </h3>
                  <div className="image-wrapper">
                    <img
                      src={WithoutVergado}
                      alt="Without Vergado"
                      loading="lazy"
                      className="natural-gif"
                    />
                  </div>
                </motion.div>
              )}

              {activeTab === "vergado" && (
                <motion.div
                  key="vergado"
                  className="text-center mt-5"
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -16 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <h3 className="color-2">
                    One central payroll hub with Vergado
                  </h3>
                  <div className="image-wrapper">
                    <img
                      src={WithVergado}
                      alt="With Vergado"
                      loading="lazy"
                      className="natural-gif"
                    />
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </section>

        <section id="home-1">
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div
              className="px-3 px-md-4 py-3 rounded-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 s-bg-color"
              style={{ minHeight: "150px" }}
            >
              <div
                className="text-white fw-bold"
                style={{ fontSize: "1rem", maxWidth: 400 }}
              >
                Solutions to fit all of your Payroll and Employment needs
              </div>

              <div className="d-flex flex-column align-items-center justify-content-center text-white flex-grow-1 text-center w-100 ">
                <small className="mb-1" style={{ fontSize: "0.7rem" }}>
                  Learn about our full suite of services
                </small>
                <button
                  className="btn btn-light btn-sm px-3 fw-semibold"
                  onClick={handleShow}
                >
                  Talk to our team
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* <section
          id="home-2"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="section-title text-center" data-aos="fade-up">
              <h2>
                All the background checks you need in one place!
                <span className="d-inline d-md-block">
                  {" "}
                  Over 25+ checks for all roles & industries
                </span>
              </h2>
            </div>
            <div className="py-4">
              <div className="row text-center">
                <div className="col-6 col-md-3 mb-4">
                  <FiUserCheck size={40} color="#4A6CF7" />
                  <p className="mt-2">ID Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiHome size={40} color="#4A6CF7" />
                  <p className="mt-2">Address Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiBriefcase size={40} color="#4A6CF7" />
                  <p className="mt-2">Employment Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiBookOpen size={40} color="#4A6CF7" />
                  <p className="mt-2">Education Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiUsers size={40} color="#4A6CF7" />
                  <p className="mt-2">Reference Check</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FaGavel size={40} color="#4A6CF7" />
                  <p className="mt-2">Court Record Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiDatabase size={40} color="#4A6CF7" />
                  <p className="mt-2">Global Database Verification</p>
                </div>
                <div className="col-6 col-md-3 mb-4">
                  <FiCreditCard size={40} color="#4A6CF7" />
                  <p className="mt-2">Credit Check</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section
          id="home-2"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="section-title text-center" data-aos="fade-up">
              <h2>
                We Onboard Your Employees,
                <span className="d-inline d-md-block">
                  {" "}
                  You Grow Your Business
                </span>
              </h2>
            </div>
            <div
              className="px-0 px-md-5"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  >
                    <MdTrackChanges style={{ marginRight: "10px" }} />
                    Application Tracking System
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                      <img
                        src={acc_1}
                        alt="Application Tracking"
                        style={{ width: "300px", height: "auto" }}
                        className="mb-3 mb-md-0"
                        loading="lazy"
                      />
                      <p className="flex-grow-1 px-0 px-md-5">
                        Vergado simplifies hiring with a smart application
                        tracking system that manages every stage of recruitment.
                        From posting job openings to shortlisting candidates and
                        scheduling interviews, everything is streamlined in one
                        place, helping HR teams save time and improve hiring
                        efficiency.
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  >
                    <MdDescription style={{ marginRight: "10px" }} />
                    Offer letter and Document Generation
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                      <img
                        src={acc_2}
                        alt="Offer letter"
                        style={{ width: "300px", height: "auto" }}
                        className="mb-3 mb-md-0"
                        loading="lazy"
                      />
                      <p className="flex-grow-1 px-0 px-md-5">
                        Generate professional offer letters and onboarding
                        documents in just a few clicks. Our platform ensures
                        consistency, compliance, and customization, allowing you
                        to send accurate, legally sound documents to candidates
                        quickly—without the hassle of manual work.
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                  >
                    <MdVerifiedUser style={{ marginRight: "10px" }} />
                    Verification and Background Checks
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3">
                      <img
                        src={acc_3}
                        alt="verification"
                        style={{ width: "300px", height: "auto" }}
                        className="mb-3 mb-md-0"
                        loading="lazy"
                      />
                      <p className="flex-grow-1 px-0 px-md-5">
                        Build trust from day one with secure employee
                        verification and background checks. Vergado partners
                        with trusted verification channels to validate
                        credentials, employment history, and identity details,
                        giving you confidence in every new hire.
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </section>
        <section
          id="home-3"
          style={{ background: "#333a80", color: "#ffffff" }}
        >
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="section-title text-center" data-aos="fade-up">
              <h2 className="text-white">Businesses grow on Vergado</h2>
              <p style={{ color: "#f0f0f0" }}>
                Vergado talks to your favorite tools and expedite the data
                exchange across your business operations.
              </p>
            </div>

            <div className="container py-4">
              <div className="row text-center justify-content-center">
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="p-4 rounded bg-white text-dark hover-card hover-purple">
                    <h3>
                      <CounterOnView to={64} />%
                    </h3>
                    <p className="mb-0">Reduction in reconciliation time</p>
                  </div>
                </div>
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="p-4 rounded bg-white text-dark hover-card hover-pink">
                    <h3>
                      <CounterOnView to={89} />%
                    </h3>
                    <p className="mb-0">Reduction in working hours</p>
                  </div>
                </div>
                <div
                  className="col-md-4 mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="p-4 rounded bg-white text-dark hover-card hover-green">
                    <h3>
                      <CounterOnView to={17} />%
                    </h3>
                    <p className="mb-0">More savings on employee cost</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="home-4"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div
            className="container-fluid container-lg"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="section-title" data-aos="fade-up">
              <h2 className="mb-0 pb-0">Quick Approvals and Notifications</h2>
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between">
              <div>
                <p>
                  Enable multi-layered approvals and notifications across the
                  Vergado ecosystem, email, and WhatsApp
                </p>
              </div>
              <div>
                <div
                  className="d-flex flex-column align-items-end"
                  style={{ gap: "10px" }}
                >
                  <motion.button
                    className="btn d-flex align-items-center gap-2 notif-pill"
                    style={{
                      background: "#F3F2F3",
                      justifyContent: "start",
                      padding: "8px 12px",
                    }}
                    initial={{ opacity: 0, x: 24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: 0 }}
                    whileHover={{ x: -6 }}
                  >
                    <img
                      src={whatsapp}
                      alt="WhatsApp"
                      style={{ width: "20px", height: "20px" }}
                      loading="lazy"
                    />
                    <span>Whatsapp</span>
                  </motion.button>
                  <motion.button
                    className="btn d-flex align-items-center gap-2 notif-pill"
                    style={{
                      background: "#F3F2F3",
                      justifyContent: "start",
                      padding: "8px 12px",
                    }}
                    initial={{ opacity: 0, x: 24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: 0.12 }}
                    whileHover={{ x: -6 }}
                  >
                    <img
                      src={messages}
                      alt="Message"
                      style={{ width: "20px", height: "20px" }}
                      loading="lazy"
                    />
                    <span>Message</span>
                  </motion.button>
                  <motion.button
                    className="btn d-flex align-items-center gap-2 notif-pill"
                    style={{
                      background: "#F3F2F3",
                      justifyContent: "start",
                      padding: "8px 12px",
                    }}
                    initial={{ opacity: 0, x: 24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: 0.24 }}
                    whileHover={{ x: -6 }}
                  >
                    <img
                      src={gmail}
                      alt="Email"
                      style={{ width: "20px", height: "20px" }}
                      loading="lazy"
                    />
                    <span>Email</span>
                  </motion.button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
          id="home-5"
          style={{ background: "#333a80", color: "#ffffff" }}
        >
          <div className="container-fluid container-lg">
            <div className="row" data-aos="zoom-in" data-aos-delay="100">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="bg-white rounded p-3">
                  <h6 className="text-dark text-center">Certifications</h6>
                  <div className="d-flex justify-content-center flex-wrap gap-5 mt-3">
                    <img
                      src={CIS}
                      alt="CIS Certification"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={GDR}
                      alt="GDPR Certification"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={SASE}
                      alt="SOC Certification"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={ISO}
                      alt="ISO Certification"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={SSL}
                      alt="SSL Certification"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="section-title text-end">
                  <h3 className="text-white mb-0">Unwavering Security,</h3>
                  <h3 className="text-white mb-0">Unmatched Scalability</h3>
                </div>
              </div>
            </div>
            <div
              className="row mt-0 mt-md-2"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="col-12 col-md-6 mb-3 mb-md-0 order-1 order-md-2">
                <div className="bg-white rounded p-3">
                  <h6 className="text-dark text-center">
                    Multi-Cloud deployment
                  </h6>
                  <div className="d-flex justify-content-center align-items-center gap-5 mt-3">
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={azure}
                        alt="Azure"
                        style={{ width: "100%" }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={aws}
                        alt="AWS"
                        style={{ width: "60px" }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={google}
                        alt="Google Cloud"
                        style={{ width: "60px" }}
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 order-2 order-md-1">
                <div className="section-title text-end">
                  <h3 style={{ color: "#f0f0f0" }}>
                    Compliance with global security standards and plug and play
                    hosting capabilities for partners.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section
          id="security"
          style={{
            background: "linear-gradient(135deg, #2f3575, #3c448a)",
            color: "#fff",
            padding: "80px 0",
          }}
        >
          <div className="container" data-aos="fade-up">
            <div className="row align-items-center flex-lg-row-reverse">
              <div className="col-lg-6 mb-4 mb-lg-0 text-center text-md-end">
                <h2 className="fw-bold mb-3">
                  Unwavering <span style={{ color: "#ff5c33" }}>Security</span>
                </h2>
                <h2 className="fw-bold mb-3">
                  Unmatched{" "}
                  <span style={{ color: "#ff5c33" }}>Scalability</span>
                </h2>
              </div>

              <div className="col-lg-6">
                <div className="bg-white text-dark rounded-4 shadow-lg p-4">
                  <h5 className="text-center fw-semibold mb-4">
                    Certifications
                  </h5>
                  <div className="d-flex justify-content-center flex-wrap gap-5 mt-3">
                    <img
                      src={CIS}
                      alt="CIS Controls"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={GDR}
                      alt="GDPR"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={SASE}
                      alt="SOC"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={ISO}
                      alt="ISO 27001"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                    <img
                      src={SSL}
                      alt="SSL Secure"
                      style={{ height: "60px" }}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="cloud"
          style={{ background: "#f2f3f6", color: "#333", padding: "80px 0" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0 text-center text-md-start">
                <p className="fs-5 text-secondary mb-0">
                  Compliance with global security standards and plug and play
                  hosting capabilities for partners.
                </p>
              </div>

              <div className="col-lg-6">
                <div className="bg-white rounded-4 shadow-lg p-4 text-center">
                  <h5 className="fw-semibold mb-4">Multi-Cloud Deployment</h5>
                  <div className="d-flex justify-content-center align-items-center gap-5 mt-3">
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={azure}
                        alt="Azure"
                        style={{ width: "100%" }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={aws}
                        alt="AWS"
                        style={{ width: "60px" }}
                        loading="lazy"
                      />
                    </div>
                    <div className="text-center" style={{ width: "90px" }}>
                      <img
                        src={google}
                        alt="Google Cloud"
                        style={{ width: "60px" }}
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="section-6" className="wizards">
          <div className="container">
            <div className="row align-items-center colrev">
              <div className="col-lg-7 responsive">
                <img
                  src={sec6}
                  className="img-fluid"
                  data-aos="fade-right"
                  width="400px"
                  loading="lazy"
                  alt="Vergado syncing payroll entries into an accounting system automatically"
                />
              </div>
              <div className="col-lg-5">
                <div className="section-title m-0 p-0">
                  <h3 className="m-0 color-1">
                    Automated entries, zero manual effort
                  </h3>
                  <h2 className="m-0 py-2 color-3">
                    Seamless Accounting Integration
                  </h2>
                  <p>
                    Vergado integrates directly with your accounting tools and
                    posts real-time entries. This eliminates manual data entry,
                    reduces errors, and ensures your books are always up to
                    date.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- ======= Platform Section ======= --> */}
        {/* <section id="platform" className="platform">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="section-title" data-aos="fade-right">
                  <h2 className="mb-2 pb-0">
                    Powerful alone, even better together.
                  </h2>
                  <p className="mb-3">
                    Connect your entire payroll and HR tech stack with
                    integrations to the systems your teams already use.
                  </p>
                  <Link className="btn btn-secondary" to="/why-vergado">
                    Explore Marketplace
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="14"
                      height="14"
                      x="0"
                      y="0"
                      viewBox="0 0 492.004 492.004"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      //  xml:space="preserve"
                      className=""
                    >
                      <g>
                        <path
                          d="M382.678 226.804 163.73 7.86C158.666 2.792 151.906 0 144.698 0s-13.968 2.792-19.032 7.86l-16.124 16.12c-10.492 10.504-10.492 27.576 0 38.064L293.398 245.9l-184.06 184.06c-5.064 5.068-7.86 11.824-7.86 19.028 0 7.212 2.796 13.968 7.86 19.04l16.124 16.116c5.068 5.068 11.824 7.86 19.032 7.86s13.968-2.792 19.032-7.86L382.678 265c5.076-5.084 7.864-11.872 7.848-19.088.016-7.244-2.772-14.028-7.848-19.108z"
                          className=""
                        ></path>
                      </g>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <!-- End Platform Section --> */}

        {/* <!-- ======= wizards Section ======= --> */}
        <section
          id="ocr"
          className="wizards dark"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div className="section-title m-0 p-0">
                  <h3 className="m-0 color-1">AI & OCR</h3>
                  <h2 className="m-0 py-2 color-3">Smart Data Processing</h2>
                  <p>
                    Seamlessly extract and analyze data from various sources
                    with advanced AI and OCR technology.
                  </p>
                </div>
              </div>
              <div className="col-lg-7 text-center mt-4 mt-md-0">
                <LazyVideo
                  src={aiOCR2}
                  style={{ width: "70%" }}
                  data-aos="fade-left"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="payments" className="wizards">
          <div className="container">
            <div className="row align-items-center colrev">
              <div className="col-lg-7 responsive">
                <img
                  src={booking}
                  className="img-fluid"
                  data-aos="fade-right"
                  width="400px"
                  loading="lazy"
                  alt="Vergado unified hub for bill payments and travel bookings"
                />
              </div>
              <div className="col-lg-5">
                <div className="section-title m-0 p-0">
                  <h3 className="m-0 color-1">
                    Bill Payments and Travel bookings
                  </h3>
                  <h2 className="m-0 py-2 color-3">Unified Transaction Hub</h2>
                  <p>
                    Streamline your financial and travel management by
                    centralizing bill payments and travel bookings within one
                    platform.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="securex"
          className="wizards dark"
          style={{ backgroundColor: "#f2f3f6", backgroundImage: "none" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div className="section-title m-0 p-0">
                  <h3 className="m-0 color-1">SecureX</h3>
                  <h2 className="m-0 py-2 color-3">
                    Proactive Safety Solutions
                  </h2>
                  <p>
                    Ensure the well-being of your employees with real-time
                    monitoring and proactive safety measures.
                  </p>
                </div>
              </div>
              <div className="col-lg-7 text-end responsive">
                <LazyVideo
                  src={secure}
                  style={{ width: "80%" }}
                  data-aos="fade-left"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="vergado-card" className="wizards">
          <div className="container">
            <div className="row align-items-center colrev">
              <div className="col-lg-7 responsive">
                <LazyVideo src={allinone} data-aos="fade-right" />
              </div>
              <div className="col-lg-5">
                <div className="section-title m-0 p-0">
                  <h3 className="m-0 color-1">Vergado Card</h3>
                  <h2 className="m-0 py-2 color-3">All-in-One Convenience</h2>
                  <p>
                    Simplify your transactions and activities with a single,
                    versatile card for multiple needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- End wizards Section --> */}

        {/* <!-- ======= FAQ Section ======= --> */}
        <section id="faq" className="wizards">
          <div className="container">
            <div className="section-title text-center" data-aos="fade-up">
              <h2 className="color-3">Frequently Asked Questions</h2>
              <p className="color-2">
                Answers to what Indian businesses ask us most about Vergado's
                fully automated HRMS.
              </p>
            </div>
            <div
              className="px-0 px-md-5"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>What is Vergado?</Accordion.Header>
                  <Accordion.Body>
                    Vergado is India's only fully automated HRMS. It runs
                    payroll, statutory compliance (TDS, EPF, ESI and PT payments
                    and filings), employee benefits, expense management and
                    onboarding end-to-end on a single multi-tenant SaaS
                    platform, so Indian businesses can operate HR with near-zero
                    manual work.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Does Vergado handle TDS, EPF, ESI and PT automatically?
                  </Accordion.Header>
                  <Accordion.Body>
                    Yes. Vergado computes, pays and files TDS (Section 192
                    salary TDS), EPF (Employees' Provident Fund), ESI
                    (Employees' State Insurance) and Professional Tax (PT)
                    across Indian states automatically every pay cycle.
                    Challans, returns and acknowledgements are generated and
                    stored without any manual intervention.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    What makes Vergado different from other HRMS platforms in
                    India?
                  </Accordion.Header>
                  <Accordion.Body>
                    Most HRMS products in India stop at calculations and leave
                    you to pay and file statutory dues yourself. Vergado is the
                    only HRMS in India that closes the loop — it calculates,
                    pays and files TDS, EPF, ESI and PT for you, and also
                    automates salary disbursal, benefits, expenses and
                    onboarding end-to-end.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Which businesses is Vergado built for?
                  </Accordion.Header>
                  <Accordion.Body>
                    Vergado is built for Indian businesses of every size —
                    startups, SMBs, and mid-market companies with white-collar,
                    blue-collar, field and contract workforces. Its multi-tenant
                    SaaS architecture scales from 10 employees to 10,000+
                    without changing systems.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Is Vergado secure and compliant?
                  </Accordion.Header>
                  <Accordion.Body>
                    Yes. Vergado is ISO 27001, SOC 2 and GDPR aligned, hosted on
                    enterprise cloud infrastructure (AWS, Azure, Google Cloud)
                    and built for Indian statutory compliance including EPFO,
                    ESIC, Income Tax and state-wise Professional Tax
                    requirements.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    How do I get started with Vergado?
                  </Accordion.Header>
                  <Accordion.Body>
                    Book a free 30-minute demo from vergado.io or email
                    sales@vergado.in. The team will walk you through payroll,
                    compliance and benefits automation for your specific
                    workforce before you switch.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </section>
        {/* <!-- End FAQ Section --> */}

        {/* <!-- ======= Book a demo ======= --> */}
        <section id="book-demo" className="book-demo">
          <div className="mini-container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title p-0" data-aos="fade-up">
                  <h2 className="mb-2 white-text text-center">
                    Ready to see what Vergado can do for you?
                  </h2>
                </div>
                <div className="subscribe-form">
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      style={{ border: isValidate ? "1px solid red" : "" }}
                      className="form-control"
                      placeholder="Your Email ID"
                      value={email}
                      onChange={(e) => {
                        handleChange(e.target.value);
                        setIsValidate("");
                      }}
                    />
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={handleBookDemo}
                    >
                      Book a demo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- End Book a demo --> */}
      </main>

      <BookDemo show={show} close={handleClose} setemail={email} />
      <VideoModal
        show={showVideo}
        onHide={() => setShowVideo(false)}
        videoId={VERGADO_OVERVIEW_VIDEO_ID}
        title="Vergado - AI Powered HR (Full Product Walkthrough)"
      />
    </>
  );
};

export default Home;
